import { useTheme } from "../../../../context/useThemeContext";
import { FaFolder } from "react-icons/fa6";
import { hexToRGBA } from "../../../../utility/hexToRGB";
import useDataStore from "../../../../stores/dataStore";

function FolderIcon(props: { id?: string }) {
    const { theme } = useTheme();

    // Store
    const folderColor = useDataStore((state) =>
        props.id
            ? theme.accentColors[state.data.folders[props.id]?.color]
            : theme.fontColor[100]
    );

    return (
        <div
            className="folderIcon flex w-[30px] h-[30px] items-center justify-center rounded"
            style={{
                backgroundColor: hexToRGBA(folderColor, 0.25),
            }}
        >
            <FaFolder
                size={16}
                style={{
                    color: folderColor,
                }}
            />
        </div>
    );
}


export default FolderIcon